// Expense  Mutations

export const updateExpenseList = (state, payload) => {
  state.expenseList = payload
}

export const fetchExpenseInfo = (state, payload) => {
  state.expenseInfo = payload
}
